module.exports = __webpack_public_path__ + "static/img/act0417.96516993.png";